var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{staticClass:"mb-0 kyc-status-radio overwrite-radio",attrs:{"id":"input-group-1","label":_vm.field.label,"label-for":_vm.field.label}},[_c('b-form-checkbox-group',{attrs:{"options":_vm.field.options,"name":"radio-options"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }